export default "__VITE_ASSET__C844CuGm__"